import { newToolFilterOAuthMcp } from "../oauth.ts";

export const stripeMcpResolver = newToolFilterOAuthMcp({
  iconUrl:
    "https://images.stripeassets.com/fzn2n1nzq965/1hgcBNd12BfT9VLgbId7By/01d91920114b124fb4cf6d448f9f06eb/favicon.svg",
  url: "https://mcp.stripe.com",
  label: "Stripe",
});
